module.exports = __webpack_public_path__ + "img/icon-arrow-left.f93129ea.svg";